import moment from "moment";
import Modal from "../../../../../components/Modal";
import {
  BodyContainer,
  CloseBtn,
  HeaderContainer,
  ModalContainer,
  TitleContainer,
} from "../../fall-analysis/style";
import { TableContainer } from "../../../../../components/DashboardComps/Dashboard.styles";
import DynamicGrid from "../../../../../components/DynamicGrid/DynamicGrid";
import {
  getDrilldownGridKey,
  useDrilldownSnapshot,
} from "../../drilldown/useDrilldownSnapshot";
import { BigBoldText } from "../../../dashboard/home/home.style";

type Props = {
  open: boolean;
  facilityName: string;
  startDate: string;
  endDate: string;
  closeFn: (open: boolean) => void;
  resetFn: (value: string) => void;
  isLoading: boolean;
  tableData: any;
  title: string;
  getUserCallback: (item: any) => void;
  handlePdfExport: () => void;
  handleCsvExport: () => void;
  tableCols?: any;
};

// Caregiver Audit drill-down (MARCC-773). Same as the Fall SectionModal — including
// DynamicGrid's built-in Excel/PDF export buttons — with showTitleBar on so the grid
// header carries a facility + caregiver + date banner into the built-in PDF (the only
// piece the Fall drill-down lacked). No custom export buttons; reportName is passed so
// the built-in PDF/Excel titles don't render a literal "undefined".
const CaregiverAuditDrilldownModal = ({
  open,
  facilityName,
  startDate,
  endDate,
  closeFn,
  resetFn,
  tableData,
  title,
  tableCols,
}: Props) => {
  const clearSnapshot = useDrilldownSnapshot("caregiver", {
    open,
    facilityName,
    startDate,
    endDate,
    title,
    tableData,
    tableCols,
  });

  return (
    <Modal open={open}>
      <ModalContainer>
        <HeaderContainer>
          <TitleContainer>
            <BigBoldText style={{ color: "#b580ff" }}>
              {" "}
              <span className="capitalize">{facilityName}</span>{" "}
            </BigBoldText>
            <div style={{ color: "#b580ff" }}>
              <p>
                {moment(startDate).format("LL")} -{" "}
                {moment(endDate).format("LL")}
              </p>
              <p>{title}</p>
            </div>
          </TitleContainer>
          <div style={{ display: "-webkit-inline-box" }}>
            <CloseBtn
              type="button"
              onClick={() => {
                clearSnapshot();
                closeFn(false);
                resetFn("");
              }}
            >
              &times;
            </CloseBtn>
          </div>
        </HeaderContainer>
        <BodyContainer>
          <TableContainer>
            <DynamicGrid
              gridCols={tableCols}
              gridData={tableData}
              showTitleBar={true}
              reportName="Caregiver Audit"
              facilityName={facilityName}
              barTitle={`${facilityName} - ${title}`}
              includeIncidentLink={true}
              viewStateKey={getDrilldownGridKey("caregiver", {
                facilityName,
                title,
                startDate,
                endDate,
              })}
              startDate={startDate}
              endDate={endDate}
              showSearchBar={false}
              filterable={true}
              sortable={true}
            />
          </TableContainer>
        </BodyContainer>
      </ModalContainer>
    </Modal>
  );
};

export default CaregiverAuditDrilldownModal;
